/**
 * Maps an IETF locale tag (e.g. 'en-GB') to the ISO-3166 alpha-2 country code
 * (lowercased) expected by ngx-intl-tel-input's `preferredCountries` (e.g. 'gb').
 * Falls back to 'us' when no valid country segment is present.
 */
export function localeToCountryIso(locale?: string | null): string {
    const country = locale?.split('-')[1]?.toLowerCase();
    return country && country.length === 2 ? country : 'us';
}
